class SlicesContract {
    constructor() {
        this.abi = [
	{
		"constant": false,
		"inputs": [
			{
				"name": "ipfsHash",
				"type": "bytes32"
			},
			{
				"name": "startMilliseconds",
				"type": "int32"
			},
			{
				"name": "endMilliseconds",
				"type": "int32"
			}
		],
		"name": "newSlice",
		"outputs": [],
		"payable": false,
		"stateMutability": "nonpayable",
		"type": "function"
	},
	{
		"constant": false,
		"inputs": [
			{
				"name": "ipfsHash",
				"type": "bytes32"
			},
			{
				"name": "startMilliseconds",
				"type": "int32[16]"
			},
			{
				"name": "endMilliseconds",
				"type": "int32[16]"
			}
		],
		"name": "newSlices16",
		"outputs": [],
		"payable": false,
		"stateMutability": "nonpayable",
		"type": "function"
	},
	{
		"constant": false,
		"inputs": [
			{
				"name": "ipfsHash",
				"type": "bytes32"
			},
			{
				"name": "startMilliseconds",
				"type": "int32[4]"
			},
			{
				"name": "endMilliseconds",
				"type": "int32[4]"
			}
		],
		"name": "newSlices4",
		"outputs": [],
		"payable": false,
		"stateMutability": "nonpayable",
		"type": "function"
	},
	{
		"constant": false,
		"inputs": [
			{
				"name": "ipfsHash",
				"type": "bytes32"
			},
			{
				"name": "startMilliseconds",
				"type": "int32[8]"
			},
			{
				"name": "endMilliseconds",
				"type": "int32[8]"
			}
		],
		"name": "newSlices8",
		"outputs": [],
		"payable": false,
		"stateMutability": "nonpayable",
		"type": "function"
	},
	{
		"constant": false,
		"inputs": [
			{
				"name": "ipfsHash",
				"type": "bytes32"
			},
			{
				"name": "tag",
				"type": "bytes32"
			},
			{
				"name": "startMilliseconds",
				"type": "int32"
			},
			{
				"name": "endMilliseconds",
				"type": "int32"
			}
		],
		"name": "newTaggedSlice",
		"outputs": [],
		"payable": false,
		"stateMutability": "nonpayable",
		"type": "function"
	},
	{
		"anonymous": false,
		"inputs": [
			{
				"indexed": true,
				"name": "user",
				"type": "address"
			},
			{
				"indexed": true,
				"name": "sampleHash",
				"type": "bytes32"
			},
			{
				"indexed": true,
				"name": "tag",
				"type": "bytes32"
			},
			{
				"indexed": false,
				"name": "startMilliseconds",
				"type": "int32"
			},
			{
				"indexed": false,
				"name": "endMillisconds",
				"type": "int32"
			}
		],
		"name": "SliceCreated",
		"type": "event"
	},
	{
		"inputs": [],
		"payable": false,
		"stateMutability": "nonpayable",
		"type": "constructor"
	}
        ];

        this.contractAddress = '0xf68a5fccacd945904dbcc675752987c72f7d5bed';
    }
}

export default SlicesContract;
